module.exports = __webpack_public_path__ + "img/person-3.261035f5.png";